if (!customElements.get('institutional-portfolio')) {
  class InstitutionalPortfolio extends HTMLElement {
    connectedCallback() {
      this.activeFilters = { type: 'all', size: 'all' };
      this.page = 0;
      this.pageSize = Math.max(1, parseInt(this.dataset.pageSize, 10) || 9);
      this.buttons = Array.from(this.querySelectorAll('[data-filter-value]'));
      this.cards = Array.from(this.querySelectorAll('[data-product-type]'));
      this.status = this.querySelector('[data-filter-status]');
      this.empty = this.querySelector('[data-filter-empty]');
      this.grid = this.querySelector('.ilc-portfolio__grid');
      this.pager = this.querySelector('[data-pager]');
      this.pageRange = this.querySelector('[data-page-range]');
      this.prevButton = this.querySelector('[data-page-prev]');
      this.nextButton = this.querySelector('[data-page-next]');
      this.messageField = document.querySelector('#cotizar textarea[name="contact[Mensaje]"]');

      const requestedProduct = new URLSearchParams(window.location.search).get('producto');
      if (requestedProduct && this.messageField && !this.messageField.value.includes(requestedProduct)) {
        this.prefillQuote(requestedProduct);
      }

      this.addEventListener('click', (event) => {
        const filter = event.target.closest('[data-filter-value]');
        if (filter) {
          const group = filter.dataset.filterGroup;
          if (!group || !(group in this.activeFilters)) return;
          this.activeFilters[group] = filter.dataset.filterValue;
          this.page = 0;
          this.buttons
            .filter((button) => button.dataset.filterGroup === group)
            .forEach((button) => button.setAttribute('aria-pressed', String(button === filter)));
          this.applyFilters();
          return;
        }

        const reset = event.target.closest('[data-filter-reset]');
        if (reset) {
          this.activeFilters = { type: 'all', size: 'all' };
          this.page = 0;
          this.buttons.forEach((button) => {
            button.setAttribute('aria-pressed', String(button.dataset.filterValue === 'all'));
          });
          this.applyFilters();
          this.buttons[0]?.focus();
          return;
        }

        const prev = event.target.closest('[data-page-prev]');
        const next = event.target.closest('[data-page-next]');
        if (prev || next) {
          this.page += next ? 1 : -1;
          this.applyFilters();
          this.revealGridTop();
          return;
        }

        const quote = event.target.closest('[data-quote-product]');
        if (quote) {
          const product = quote.dataset.quoteProduct;
          if (this.messageField) {
            this.prefillQuote(product);
          } else {
            const destination = new URL(quote.href, window.location.origin);
            destination.searchParams.set('producto', product);
            quote.href = `${destination.pathname}${destination.search}${destination.hash}`;
          }
        }
      });

      this.applyFilters();
    }

    prefillQuote(product) {
      if (!this.messageField || !product || this.messageField.value.includes(product)) return;
      const prefix = `Me interesa cotizar: ${product}.`;
      this.messageField.value = this.messageField.value.trim()
        ? `${prefix}\n${this.messageField.value}`
        : prefix;
      this.messageField.dispatchEvent(new Event('input', { bubbles: true }));
    }

    applyFilters() {
      const matches = this.cards.filter((card) => {
        // Liquid captures can include surrounding whitespace, including a
        // trailing newline from a rendered snippet. Match the value only.
        const productType = (card.dataset.productType || '').trim();
        const productSize = (card.dataset.productSize || '').trim();
        const matchesType = this.activeFilters.type === 'all'
          || productType === this.activeFilters.type;
        const matchesSize = this.activeFilters.size === 'all'
          || productSize === this.activeFilters.size;
        return matchesType && matchesSize;
      });
      const total = matches.length;
      const pages = Math.max(1, Math.ceil(total / this.pageSize));
      this.page = Math.min(Math.max(this.page, 0), pages - 1);
      const start = this.page * this.pageSize;
      const end = Math.min(start + this.pageSize, total);
      const visible = new Set(matches.slice(start, end));

      this.cards.forEach((card) => { card.hidden = !visible.has(card); });

      const range = total === 0
        ? 'Sin formatos para ese filtro'
        : total <= this.pageSize
          ? (total === 1 ? '1 formato' : `${total} formatos`)
          : `${start + 1}–${end} de ${total} formatos`;

      if (this.status) this.status.textContent = range;
      if (this.pageRange) this.pageRange.textContent = range;
      if (this.empty) this.empty.hidden = total !== 0;
      if (this.pager) this.pager.hidden = pages <= 1;
      if (this.prevButton) this.prevButton.disabled = this.page === 0;
      if (this.nextButton) this.nextButton.disabled = this.page >= pages - 1;
    }

    revealGridTop() {
      if (!this.grid) return;
      const top = this.grid.getBoundingClientRect().top;
      if (top >= 0) return;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const anchor = this.querySelector('.ilc-portfolio__filters') || this.grid;
      anchor.scrollIntoView({ block: 'start', behavior: reduce ? 'auto' : 'smooth' });
    }
  }

  customElements.define('institutional-portfolio', InstitutionalPortfolio);
}
